import { useTranslate } from 'react-t7e';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { H1 } from 'src/components/common/typography/Header';
import { media } from 'src/styles/designs';
import styled from 'styled-components';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';

const Container = styled.main`
  padding: 50px 0;
`;

const Description = styled.div`
  font-weight: 300;
  line-height: 1.5;
  max-width: 620px;

  ${media.w.lessThan.desktop} {
    font-size: 14px;
  }
`;

export const LocalExpertsIntroduction = () => {
  const { _ } = useTranslate();

  return (
    <Container>
      <ConstraintContainer>
        <H1 as="h2" $nail="outside">
          {_('Local experts')}
        </H1>
        <Description>
          <Markdown>{_('experts.local.description')}</Markdown>
        </Description>
      </ConstraintContainer>
    </Container>
  );
};
